import { useParams } from "react-router";
import { ProfileNav } from "../../../components/profileNav.component";
import { useState } from "react";
import { ProfileCard } from "../../../features/company/profile/profileCard.component";
import { ApiCompany } from "../../../core/apis/company";
import { CompanyInformation } from "../../../features/company/profile/companyInformation";
import { CompanyPatientList } from "../../../features/company/profile/companyPatientList.component";
import { CompanyCaregiverList } from "../../../features/company/profile/companyCaregiverList.component";
import { CompanyAppointmentCalendar } from "../../../features/company/profile/companyAppointment.component";
import { ApiAppointment } from "../../../core/apis";
import { Settings } from "../../../features/settings/settings.component";
import { ComingSoon } from "../../../components/comingSoon.component";
import { CompanyActivityLogCard } from "../../../features/company/profile/activityLogCard.component";

export const PageSingleCompany = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { data, isValidating } = ApiCompany.AllDetails.Hook(companyId);
  const [selectedPage, setSelectedPage] = useState("Company Information");
  const { data: appointmentData, isValidating: isAppointmentValidating } =
    ApiAppointment.ByDateRange.Hook(companyId);

  const pages: { [key: string]: string | JSX.Element } = {
    "Company Information": (
      <CompanyInformation
        data={data?.companyDetails}
        isValidating={isValidating}
      />
    ),
    "Appointment List": (
      <CompanyAppointmentCalendar
        data={appointmentData}
        isValidating={isAppointmentValidating}
      />
    ),
    "Patient List": <CompanyPatientList />,
    "Caregiver List": <CompanyCaregiverList />,
    "Activity log": <CompanyActivityLogCard />,
    "Financial Log": <ComingSoon />,
    Setting: (
      <Settings hideAccountSettings hideChangePassword expandTaskSettings />
    ),
  };

  return (
    <>
      <ProfileCard data={data?.companyDetails} isValidating={isValidating} />

      <ProfileNav
        items={[
          "Company Information",
          "Appointment List",
          "Patient List",
          "Caregiver List",
          "Activity log",
          // "Financial Log",
          "Setting",
        ]}
        active={selectedPage}
        onSelect={setSelectedPage}
      />

      {pages[selectedPage]}
    </>
  );
};
